import React from "react";

import Header from "../Templete/Header";
import HeroBanner from "./HeroBanner";
import Footer from "../Templete/Footer";
import WhyChooseUs from "./WhyChooseUs";
import OurServices from "./OurServices";
import RechargeProcess from "./RechargeProcess";
import Faq from "./Faq";
import AboutSection from "./AboutSection";

const Home = () => {
  return (
    <React.Fragment>
      <Header />

      <HeroBanner />

      <OurServices />

      <AboutSection />

      <RechargeProcess />

      <WhyChooseUs />

      <Faq />

      <Footer />
    </React.Fragment>
  );
};

export default Home;
